import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReports = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 11H1.5C1.22386 11 1 11.2239 1 11.5V16.5C1 16.7761 1.22386 17 1.5 17H4.5C4.77614 17 5 16.7761 5 16.5V11.5C5 11.2239 4.77614 11 4.5 11Z",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7004 6.29959H7.81628C7.54014 6.29959 7.31628 6.52344 7.31628 6.79959V16.5C7.31628 16.7761 7.54014 17 7.81628 17H10.7004C10.9765 17 11.2004 16.7761 11.2004 16.5V6.79959C11.2004 6.52345 10.9765 6.29959 10.7004 6.29959Z",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8165 1H13.9324C13.6563 1 13.4324 1.22386 13.4324 1.5V16.5C13.4324 16.7761 13.6563 17 13.9324 17H16.8165C17.0927 17 17.3165 16.7761 17.3165 16.5V1.5C17.3165 1.22386 17.0927 1 16.8165 1Z",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgReports);
export default ForwardRef;
